/**

 * PMR Theme Colors (JavaScript)

 * ─────────────────────────────

 * Kin Health inspired palette — keep in sync with theme.css

 */

export const themeColors = {

  primary: '#e35336',

  primaryHover: '#d14024',

  btnPrimary: '#1a1a1a',

  btnPrimaryHover: '#2d2d2d',

  secondary: '#d14024',

  danger: '#dc2626',

  success: '#2d6a4f',

  successAlt: '#198754',

  accent: '#e35336',

  text: '#43403c',

  textDark: '#1a1a1a',

  textHeading: '#1a1a1a',

  textMuted: '#8c8986',

  white: '#ffffff',

  black: '#1a1a1a',

  bg: '#faf7f4',

  bgMuted: '#eae8e6',

  bgSubtle: '#fff1e6',

  bgWarmStrong: '#ffe2cb',

  headerBg: '#faf7f4',

  gridHeaderBg: '#fff1e6',

  gridRowHover: '#fff1e6',

  gridRowSelected: '#fff1e6',

  gridRowAlt: '#ffffff',

  iconBg: '#fff1e6',

  iconColor: '#e35336',

  border: '#e5e7eb',

  star: '#ffbb00',

  statusSuccess: '#28a745',
  statusWarning: '#f7b731',
  statusError: '#dc143c',
  bgLight: '#f8f8f8',

  popupStatusWidth: '480px',

};



/** CSS variable reference for inline styles in JSX */

export const cssVar = {

  primary: 'var(--pmr-primary)',

  btnPrimary: 'var(--pmr-btn-primary)',

  secondary: 'var(--pmr-secondary)',

  danger: 'var(--pmr-danger)',

  success: 'var(--pmr-success)',

  accent: 'var(--pmr-accent)',

  text: 'var(--pmr-text)',

  textMuted: 'var(--pmr-text-muted)',

  white: 'var(--pmr-white)',

  bg: 'var(--pmr-bg)',

  bgSubtle: 'var(--pmr-bg-subtle)',

  iconColor: 'var(--pmr-icon-color)',

  statusSuccess: 'var(--pmr-status-success)',
  statusWarning: 'var(--pmr-status-warning)',
  statusError: 'var(--pmr-status-error)',

  popupStatusWidth: 'var(--pmr-popup-status-width)',

};


